import { render } from "./SwapHistoryModal.vue?vue&type=template&id=524fc066&scoped=true"
import script from "./SwapHistoryModal.vue?vue&type=script&lang=js"
export * from "./SwapHistoryModal.vue?vue&type=script&lang=js"

import "./SwapHistoryModal.vue?vue&type=style&index=0&id=524fc066&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524fc066"]])

export default __exports__